var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540.71 425.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:var(--primary-color);}.cls-2{fill:var(--primary-color);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312,124.27q95.28,0,190.57,0c25.88,0,38.12,12.31,38.12,38.36q0,113.09,0,226.19c0,24.05-13.12,37.08-37.18,37.07H120.77q-37.95,0-38-37.75,0-113.89,0-227.78c0-22.92,12.73-36,35.53-36q96.85-.15,193.73,0Zm-.27,111.86c-66.67,0-133.34.1-200-.14-7.22,0-9.52,2-9.47,9.31.29,47.71.12,95.41.17,143.12,0,13,4.47,17.39,17.69,17.39q191.73,0,383.44,0c12.95,0,17.11-4.09,17.12-17,.05-47.71-.14-95.41.18-143.12,0-7.7-2.37-9.71-9.89-9.68C444.56,236.25,378.15,236.14,311.74,236.13Zm-.89-53.33h191.4c18.49,0,18.49,0,18.46-18.33,0-17.14-3.28-20.45-20.2-20.45q-185.07,0-370.15,0c-27.17,0-28,.69-27.93,27.81,0,11,0,11,10.69,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.93,103.27H452.08q-166.86,0-333.74,0c-26.15,0-45.68,12.94-53.56,36.27-2.3,6.83-3.05,14.47-3.07,21.74-.23,63.8-.13,127.61-.13,191.42v8.68c-10.17-1.45-18.2-10.48-20.63-23.23-2.66-14-5-28-7.45-42Q19.74,217.06,6,138C4.18,127.35,2,116.75.44,106.07c-2.83-19,8.16-34.85,27-38.2q93-16.53,186.09-32.6Q312.83,17.94,412.12.64c19.34-3.39,35.47,6.82,39.31,26.2,4.72,23.78,8.61,47.72,12.8,71.6C464.44,99.65,464.09,101,463.93,103.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.33,373.81c-10.8,0-21.6.1-32.39,0-11.29-.14-17-5.76-17.16-17q-.27-22.11,0-44.24c.12-10.91,5.69-16.46,16.7-16.53q32.79-.22,65.57,0c11.64.07,17.07,5.4,17.2,16.83q.26,22.13,0,44.25c-.13,10.82-5.85,16.52-16.67,16.71C458.45,374,447.39,373.81,436.33,373.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 102.26,
    y: 175.07,
    width: 418.46,
    height: 68.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCard);
export default __webpack_public_path__ + "static/media/paymentCard.ac7be72466856af0053c5cf53f26534a.svg";
export { ForwardRef as ReactComponent };